import React from 'react';
import SupplementQuiz from '../components/supplements/SupplementQuiz';

// The public, no-account picker at /quiz. Shareable from the YouTube channel.
// Same honest engine as the signed-in page; it works with zero data and
// softly invites signing up to track whether a supplement does anything.

const SupplementQuizPage = () => (
  <div className="mx-auto max-w-[1080px] px-4 sm:px-6 lg:px-10">
    <div className="mb-[22px]">
      <h1 className="text-[1.75rem] font-medium leading-[1.15] tracking-[-0.02em]">The honest supplement quiz</h1>
      <p className="mt-1 max-w-[40em] text-fg-3">Pick what you’d like to improve. We say what’s worth taking, what food covers, and what to skip. No account, no hype.</p>
    </div>
    <SupplementQuiz heading="What would you like to improve?" subheading="Pick one or a few." />
  </div>
);

export default SupplementQuizPage;
